import { render, staticRenderFns } from "./EditLogs.vue?vue&type=template&id=159a6c8c&scoped=true"
import script from "./EditLogs.vue?vue&type=script&lang=js"
export * from "./EditLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a6c8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('159a6c8c')) {
      api.createRecord('159a6c8c', component.options)
    } else {
      api.reload('159a6c8c', component.options)
    }
    module.hot.accept("./EditLogs.vue?vue&type=template&id=159a6c8c&scoped=true", function () {
      api.rerender('159a6c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/commodity/dialog/EditLogs.vue"
export default component.exports